export const adminDriverSelector = state => state.adminDriverReducer;
